var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "picture",
    {
      directives: [
        {
          name: "lazyload",
          rawName: "v-lazyload",
          value: _vm.lazyLoad,
          expression: "lazyLoad",
        },
      ],
      ref: "ric-" + _vm.id,
      staticClass: "responsive-image-wrapper tourdata-image",
      style: _vm.pictureStyle,
      attrs: { id: "responsive-image-component-" + _vm.id },
    },
    [
      _vm._l(_vm.breakpoints, function (breakpoint, viewport) {
        return _vm.getImgUrlByViewport(viewport)
          ? _c("source", {
              attrs: {
                media: _vm.constructMediaQuery(viewport),
                "data-srcset": _vm.constructSrcSet(viewport),
              },
            })
          : _vm._e()
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "img-responsive",
        class: _vm.imgClass,
        style: _vm.imgStyle,
        attrs: { "data-src": _vm.src, title: _vm.title, alt: _vm.alt },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }